export const quizQuestions = [
  {
    id: "question16",
    videoId: "video16",
    topic: "TSMR",
    question: "This reduces the risks of accidents:",
    options: ["Overtaking Properly", "Defensive Driving", "Exercising caution"],
    correctAnswer: "Defensive Driving",
    descriptionTitle: "BUS STOP Sign",
    description1:
      "A Bus Stop sign is a road traffic sign that indicates the location where buses are authorized to stop to pick up or drop off passengers. It serves as a designated point on the road where public transportation vehicles, such as buses, are expected to stop to allow passengers to board or disembark.",
  },
  {
    id: "question17",
    videoId: "video17",
    topic: "TSMR",
    question: "Proactive and Defensive Driving means:",
    options: [
      "Minimizing accidents and risk through defensive strategies",
      "Being aggressive to avoid collision",
      "None of the above",
    ],
    correctAnswer: "Minimizing accidents and risk through defensive strategies",
    descriptionTitle: "BUS STOP Sign",
    description1:
      "A Bus Stop sign is a road traffic sign that indicates the location where buses are authorized to stop to pick up or drop off passengers. It serves as a designated point on the road where public transportation vehicles, such as buses, are expected to stop to allow passengers to board or disembark.",
  },
  {
    id: "question18",
    videoId: "video18",
    topic: "TSMR",
    question: "In situations where collision is imminent:",
    options: [
      "Ride of the Road",
      "Stop the car",
      "Turn of the gas and slam the brakes",
    ],
    correctAnswer: "Ride of the Road",
    descriptionTitle: "BUS STOP Sign",
    description1:
      "A Bus Stop sign is a road traffic sign that indicates the location where buses are authorized to stop to pick up or drop off passengers. It serves as a designated point on the road where public transportation vehicles, such as buses, are expected to stop to allow passengers to board or disembark.",
  },
];
